import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Button } from '@delmonicos/shared-design-system-react/src/components/button/button';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { useTranslation } from 'react-i18next';

import {
  ChargePointChannelContextProvider,
  ChargePointContextProvider,
} from '@app/feature/charge-point/charge-point.context';

import { ChannelCardComponent } from './charge-point-card/channel-card/channel-card.component';
import * as css from './location-charge-point-list.module.scss';

interface LocationChargePointListViewProps {
  resource?: TransformedPaginatedData<GatewayChargePointModel>;
  onActionUpdate: () => void;
  onActionRead: (id: string) => void;
}

export const LocationChargePointListView = ({
  resource,
  onActionUpdate,
  onActionRead,
}: LocationChargePointListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // LIST //////////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <div className={css.chargePointListView}>
      <div className={css.chargePointListContainer}>
        {resource?.docs.map((chargePoint) => (
          <ChargePointContextProvider key={chargePoint.id} data={chargePoint}>
            <Card gap={GapEnum.M}>
              <Stack justifyContent="space-between" alignItems="center">
                <AccentTitle
                  variant={AccentVariantEnum.Surface}
                  icon="electric-terminal"
                  text={chargePoint.name ?? chargePoint.id}
                />
                <button onClick={() => onActionRead(chargePoint.id)}>
                  <Icon name="chevron-right" />
                </button>
              </Stack>
              <div className={css.connectorsContainer}>
                {chargePoint.channels.map((channel) => (
                  <ChargePointChannelContextProvider
                    key={channel.id}
                    data={channel}>
                    <ChannelCardComponent />
                  </ChargePointChannelContextProvider>
                ))}
              </div>
            </Card>
          </ChargePointContextProvider>
        ))}
      </div>
      <div className={css.actionButtons}>
        <Button onClick={onActionUpdate}>
          <Icon name="link-01" />
          <Text>{t('$.location-charge-point-list-update.title')}</Text>
        </Button>
      </div>
    </div>
  );
};
